/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";

const initState = {
    open: false,
    id: 0,
    name: "",
    task_template: {},
};

const TaskTemplateModalContext = React.createContext(initState);
export const useTaskTemplateModalData = () =>
    React.useContext(TaskTemplateModalContext);

const TaskTemplateModalSwitchContext = React.createContext(() => {});
export const useSwitchTaskTemplateModalData = () =>
    React.useContext(TaskTemplateModalSwitchContext);

export default ({ children }) => {
    const [value, setValue] = React.useState(() => initState);
    return (
        <TaskTemplateModalContext.Provider value={value}>
            <TaskTemplateModalSwitchContext.Provider
                value={(value) => {
                    if (typeof value === "function") setValue(value);
                    else if (typeof value === "object")
                        setValue((state) => ({ ...state, ...value }));
                }}
            >
                {children}
            </TaskTemplateModalSwitchContext.Provider>
        </TaskTemplateModalContext.Provider>
    );
};
